var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoCameraAlt2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_464_439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M488.597 139.477C474.176 132.267 457.173 133.781 444.288 143.488C443.456 144.106 442.667 144.811 441.941 145.536L404.459 183.36C399.957 128.64 354.517 85.3545 298.667 85.3545H106.667C47.8507 85.3332 0 133.184 0 192V320C0 378.816 47.8507 426.667 106.667 426.667H298.667C354.752 426.667 400.384 382.997 404.523 327.957L441.984 365.376C442.709 366.08 443.456 366.72 444.267 367.339C451.776 372.971 460.651 375.829 469.611 375.829C476.075 375.829 482.539 374.357 488.597 371.328C503.04 364.117 512 349.589 512 333.483V177.365C512 161.216 503.04 146.688 488.597 139.477ZM298.667 384H106.667C71.3813 384 42.6667 355.285 42.6667 320V192C42.6667 156.715 71.3813 128 106.667 128H298.667C333.952 128 362.667 156.715 362.667 192V320C362.667 355.285 333.952 384 298.667 384ZM405.333 268.437V243.072L469.333 178.475L469.867 332.885L405.333 268.416V268.437Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_464_439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCameraAlt2);
export default __webpack_public_path__ + "static/media/video-camera-alt 2.7e08d18e2ce036fc2a3fb6875f9ac6d5.svg";
export { ForwardRef as ReactComponent };